// extracted by mini-css-extract-plugin
export default {"header":"Header_header__GktNF","header_sub_container":"Header_header_sub_container__l-nsv","tab":"Header_tab__+LY-K","text":"Header_text__vCeZ4"};